"use strict";
import React from "react";
import _ from "underscore";
import CarrierTypeAhead from "./carrier_typeahead";
import ReactUtils from "../react_utils";
import DocumentTitle from "react-document-title";
import Account from "../api/account";
import Auth from "../util/auth";
const bem = ReactUtils.makeBem("carrier-setter");
class CarrierSetter extends React.Component {
  constructor(props) {
    super(props);
    const formDisabled = Auth._currentUser.account.tms === "BusinessManager";
    this.state = {
      carrier: this.startCarrierIfNotUnknownCarrier(),
      contactInfo: null,
      displayErrors: false,
      isMultipleChecked: !this.props.isSingleCarrier,
      enableFactorClientPortal: this.factorProcess(),
      formDisabled
    };
  }
  startCarrierIfNotUnknownCarrier() {
    if (this.props.carrier && this.props.carrier.id) {
      return this.props.carrier;
    }
    return null;
  }
  componentDidUpdate(prevProps) {
    if (this.props.saving !== prevProps.saving) {
      this.setState({ saving: this.props.saving });
    }
  }
  carrierSelected(carrier) {
    this.setState({
      carrier,
      displayErrors: false,
      isMultipleChecked: false
    });
  }
  carrierCleared() {
    this.setState({
      carrier: null
    });
  }
  setContactInfo(changeEvent) {
    this.setState({
      contactInfo: changeEvent.target.value
    });
  }
  setEnableFactorClientPortal(changeEvent) {
    this.setState({
      enableFactorClientPortal: !this.state.enableFactorClientPortal
    });
  }
  toggledMultiple() {
    this.setState({
      isMultipleChecked: !this.state.isMultipleChecked
    });
  }
  setCarrier() {
    if (this.state.isMultipleChecked || this.state.carrier) {
      this.setState({ saving: true });
      this.props.onSetCarrier({
        isSingleCarrier: !this.state.isMultipleChecked,
        carrierId: _.isNull(this.state.carrier) ? null : this.state.carrier.id,
        contactInfo: this.state.contactInfo,
        enableFactorClientPortal: this.state.enableFactorClientPortal
      });
    } else {
      this.setState({
        displayErrors: true
      });
    }
  }
  render() {
    const typeaheadClass = this.state.isMultipleChecked ? bem("__typeahead-multi-checked") : "";
    return /* @__PURE__ */ React.createElement(
      DocumentTitle,
      {
        title: "TriumphPay Audit \u2013 Assign " + Account.carrierTerm()
      },
      /* @__PURE__ */ React.createElement("div", { className: bem(""), "data-component": "CarrierSetter" }, /* @__PURE__ */ React.createElement("h3", null, "Assign ", Account.carrierTerm()), this.errors(false), /* @__PURE__ */ React.createElement("div", { className: bem() }, /* @__PURE__ */ React.createElement("div", { className: bem("__choice") }, /* @__PURE__ */ React.createElement("div", { className: bem("__typeahead-wrapper") }, /* @__PURE__ */ React.createElement("div", { className: bem("__typeahead-label") }, /* @__PURE__ */ React.createElement("label", null, "A Single ", Account.carrierTerm(), ":")), /* @__PURE__ */ React.createElement("div", { className: bem("__typeahead-input-container") }, /* @__PURE__ */ React.createElement("div", { className: typeaheadClass }, /* @__PURE__ */ React.createElement(
        CarrierTypeAhead,
        {
          onSelectCarrier: this.carrierSelected.bind(this),
          onClearCarrier: this.carrierCleared.bind(this),
          showTextArea: true,
          carrier: this.state.carrier,
          readOnly: this.choiceDisabled(),
          onSubmit: this.setCarrier.bind(this),
          autoFocus: !this.state.isMultipleChecked
        }
      )), /* @__PURE__ */ React.createElement(
        "div",
        {
          className: bem("__typeahead-help-text") + " show_for_reskin"
        },
        this.tooltipText()
      ), /* @__PURE__ */ React.createElement(
        "div",
        {
          className: bem("__tooltip-icon") + " fi-info show_for_non_reskin",
          "data-tooltip": true,
          "aria-haspopup": "true",
          title: this.tooltipText()
        }
      )))), /* @__PURE__ */ React.createElement("div", { className: bem("__choice") }, /* @__PURE__ */ React.createElement("label", null, /* @__PURE__ */ React.createElement(
        "input",
        {
          className: bem("__multiple-checkbox"),
          onChange: this.toggledMultiple.bind(this),
          type: "checkbox",
          checked: this.state.isMultipleChecked || this.props.isReceivablesEmail,
          disabled: this.choiceDisabled(),
          autoFocus: this.state.isMultipleChecked
        }
      ), /* @__PURE__ */ React.createElement("div", { className: bem("__multiple-carrier") }, this.multipleCarriersText())))), this.props.contact && !this.state.isMultipleChecked ? this.contactInfo() : "", this.actionBar(bem), this.errors(true))
    );
  }
  tooltipText() {
    const lowerCaseTerm = Account.carrierTerm().toLowerCase();
    const standard = `Start typing the ${lowerCaseTerm} name to search for ${lowerCaseTerm} profiles with that name. Use arrow keys and "Enter" to select the ${lowerCaseTerm} for this email.`.replace(
      /\s+/g,
      " "
    );
    const receivables = `Cannot assign ${lowerCaseTerm} to items delivered to Receivables inbox.`;
    return this.props.isReceivablesEmail ? receivables : standard;
  }
  multipleCarriersText() {
    return this.props.disallowMultiple ? `Unknown ${Account.carrierTerm()}` : `Multiple ${Account.carrierTerm()}s / Unknown ${Account.carrierTerm()}`;
  }
  actionBar(bem2) {
    return /* @__PURE__ */ React.createElement("div", { className: bem2("__actions") }, this.possibleLeftCancelButton(), this.setCarrierButton());
  }
  possibleLeftCancelButton() {
    if (this.props.canCancel) {
      return /* @__PURE__ */ React.createElement("span", { className: "button--left-cancel-wrapper" }, /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "button--cancel",
          disabled: this.state.formDisabled,
          onClick: this.props.onCancel
        },
        "cancel"
      ), /* @__PURE__ */ React.createElement("span", { className: "button--cancel-or" }, "or"));
    }
  }
  setCarrierButton() {
    if (this.state.saving) {
      return /* @__PURE__ */ React.createElement("button", { disabled: true }, "Saving...");
    } else {
      return /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "carrier-setter__submit",
          disabled: this.state.formDisabled,
          onClick: this.setCarrier.bind(this)
        },
        "Assign ",
        Account.carrierTerm()
      );
    }
  }
  contactInfo() {
    return /* @__PURE__ */ React.createElement("div", { className: "carrier-setter__contact-info" }, /* @__PURE__ */ React.createElement("p", null, "This email address"), /* @__PURE__ */ React.createElement("p", { className: "carrier-setter__email" }, this.props.contact.email), /* @__PURE__ */ React.createElement("p", null, "is used to send emails:"), _.map(this.contactInfoOptions(), this.radioButton.bind(this)), /* @__PURE__ */ React.createElement("hr", { className: "carrier-setter__rule" }));
  }
  errors(forReskin) {
    if (this.state.displayErrors) {
      const className = forReskin ? "show_for_reskin" : "show_for_non_reskin";
      return /* @__PURE__ */ React.createElement("div", { className: "alert-box alert " + className }, /* @__PURE__ */ React.createElement("span", null, "Please enter a ", Account.carrierTermLower()));
    }
  }
  contactInfoOptions() {
    return [
      {
        value: "single",
        label: "Only for this " + Account.carrierTermLower()
      },
      {
        value: "multiple",
        label: "For multiple " + Account.carrierTermLower() + "s"
      },
      {
        value: "unknown",
        label: "I'm not sure"
      }
    ];
  }
  radioButton(contactInfoOption, index) {
    return /* @__PURE__ */ React.createElement("span", { key: "radio-button-" + index }, /* @__PURE__ */ React.createElement("label", null, /* @__PURE__ */ React.createElement(
      "input",
      {
        onChange: this.setContactInfo.bind(this),
        type: "radio",
        name: "contactInfo",
        value: contactInfoOption.value,
        checked: this.state.contactInfo === contactInfoOption.value
      }
    ), /* @__PURE__ */ React.createElement("span", null, " " + contactInfoOption.label)), this.enableFactorClientPortalCheckBox(contactInfoOption));
  }
  enableFactorClientPortalCheckBox(contactInfoOption) {
    if (this.factorProcess() && contactInfoOption.value === "single" && this.state.contactInfo === "single") {
      return /* @__PURE__ */ React.createElement("label", null, /* @__PURE__ */ React.createElement(
        "input",
        {
          onChange: this.setEnableFactorClientPortal.bind(this),
          type: "checkbox",
          name: "enableFactorClientPortal",
          checked: this.state.enableFactorClientPortal
        }
      ), " grant client portal access to this contact");
    }
  }
  factorProcess() {
    const account = Auth._currentUser.account;
    return account.factor_account && account["factor_client_portal_enabled?"];
  }
  choiceDisabled() {
    return this.state.formDisabled || this.props.isReceivablesEmail;
  }
}
export default CarrierSetter;
